// 限时活动展示处理
import { ITagThemes } from 'base/store/serverStore'
import { getTimeStamp } from 'base/utils/date'

/**
 * 获取当前标签样式配置
 */
export const getCurrentTagTheme = (tagThemeData: ITagThemes): ITagThemes => {
    const nowTimeStamp = getTimeStamp()
    let curtTagTheme

    if (tagThemeData.activity?.length) {
        curtTagTheme = {}
    }

    tagThemeData?.activity?.map((actItem) => {
        const { activityCode = '', styles } = actItem

        // 活动code 转小写 key
        const _activityCode = activityCode.toLowerCase()

        // 当前时间段
        const curtStylesConfig = styles.find((sItem) => {
            return sItem.startTime <= nowTimeStamp && nowTimeStamp < sItem.endTime
        })
        if (!!curtStylesConfig) {
            // 排除时间 取每个位置的样式配置
            const { startTime, endTime, ...restSitesStyle } = curtStylesConfig || {}
            const sitesStyles = restSitesStyle || {}
            let siteStyleConfig = {}
            for (const siteKey in sitesStyles) {
                siteStyleConfig[siteKey] = sitesStyles?.[siteKey] || {}
            }
            curtTagTheme[_activityCode] = {
                startTime,
                endTime,
                ...siteStyleConfig
            }

        } else {
            curtTagTheme[_activityCode] = {}
        }
    })

    return {
        activity: tagThemeData.activity,
        current: curtTagTheme
    }
}